import { SubstitutionReportType } from '@bp/planung-graphql-types';
import { Table, TableColumns } from '@bp/ui-components';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

export type SubstitutionStatisticTypesTableType = {
  type: SubstitutionReportType;
  name: string;
};

type SubstitutionStatisticTypesTableProps = {
  // data: TeachingLoadReportTypesTableType[];
  onSelect: (type: SubstitutionReportType, headline: string) => void;
};

export const SubstitutionStatisticTypesTable = ({ onSelect }: SubstitutionStatisticTypesTableProps) => {
  const { t } = useTranslation();

  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  // Stabile Referenzen: die Tabelle setzt bei neuen data/columns/rowSelection ihren Zustand zurück.
  const data: SubstitutionStatisticTypesTableType[] = useMemo(
    () => [
      { type: SubstitutionReportType.StatisticTotal, name: t('substitutions.statistics.pdfTotal') },
      { type: SubstitutionReportType.StatisticMonth, name: t('substitutions.statistics.pdfMonthly') },
      { type: SubstitutionReportType.StatisticExcel, name: t('substitutions.statistics.excelMonthly') },
    ],
    [t],
  );

  const columns: TableColumns<SubstitutionStatisticTypesTableType>[] = useMemo(
    () => [
      {
        header: '',
        id: 'name',
        accessorKey: 'name',
        canExpand: true,
      },
    ],
    [],
  );

  const rowSelection = useMemo(() => ({ [selectedIndex]: true }), [selectedIndex]);
  return (
    <Table<SubstitutionStatisticTypesTableType>
      data={data}
      columns={columns}
      hideHeader
      onRowClick={(e, row) => {
        setSelectedIndex(parseInt(row.id));
        onSelect(row.original.type, row.original.name);
      }}
      showRowHover
      rowSelection={rowSelection}
      showSelected
      customPadding='var(--spacing-6)'
    />
  );
};
